const MOMENT_LABELS = {
  en_ayunas: '🌅 En ayunas',
  pre_entreno: '💪 Pre-entreno',
  intra_entreno: '⚡ Intra-entreno',
  antes_dormir: '🌙 Antes de dormir',
  con_comida_1: '🍽️ Con comida 1',
  con_comida_2: '🍽️ Con comida 2',
  con_comida_3: '🍽️ Con comida 3',
  con_comida_4: '🍽️ Con comida 4',
  con_comida_5: '🍽️ Con comida 5',
};

/**
 * Bloque de suplementación que se muestra dentro del plan de comidas de la
 * clienta Fit Evolution. Se colapsa si no hay ítems para ese momento.
 * Todos los textos son estáticos (sin IA). Los datos los obtiene el padre
 * con un único fetch y se pasan por props.
 */
export default function SupplementsBlock({ moment, items = [], note = '', className = '' }) {
  if (!items || items.length === 0) return null;

  return (
    <div
      className={`rounded-2xl p-4 md:p-5 ${className}`}
      style={{
        background: 'linear-gradient(135deg, rgba(236,72,153,0.10), rgba(168,85,247,0.08))',
        border: '1px solid rgba(236,72,153,0.35)',
      }}
      data-testid={`supplements-block-${moment}`}
    >
      <p className="text-[10px] uppercase tracking-widest text-pink-300 font-bold mb-1">
        Suplementación
      </p>
      <h4
        className="text-base md:text-lg font-black text-white mb-2"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        {MOMENT_LABELS[moment] || moment}
      </h4>
      <ul className="space-y-2">
        {items.map((s, i) => (
          <li
            key={s.id || i}
            className="p-2 rounded-lg bg-black/25 border border-white/10"
            data-testid={`supplements-item-${moment}-${i}`}
          >
            <div className="flex justify-between items-start gap-2">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-white">{s.name}</p>
                {s.dosage && <p className="text-xs text-pink-200">Dosis: {s.dosage}</p>}
                {s.timing && <p className="text-xs text-cyan-200">⏱️ {s.timing}</p>}
                {s.instructions && <p className="text-xs text-white/70 mt-0.5">{s.instructions}</p>}
                {s.contraindications && (
                  <p className="text-[11px] text-amber-200 mt-1">🚨 {s.contraindications}</p>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
      {note && (
        <p className="text-[11px] text-white/60 italic mt-2">{note}</p>
      )}
    </div>
  );
}
